<!-- eslint-disable -->
<template>
<div>
<transition name="zoom-m">
   
  <div v-if="showing" id="modal-receta-m" >
    
  <div v-on:click="hide();" class="contenedor-icono">       
    <b-icon class="icon" icon="x"></b-icon>
  </div>
  <div class="header-container-m">
    <h2> Descargas</h2>
    <div class="help-button-container" @click="showHelp = !showHelp">
      <b-icon :icon="showHelp ? 'question-circle-fill' : 'question-circle'" class="help-icon"></b-icon>
    </div>
  </div>

  <transition name="slide-fade">
    <div v-if="showHelp" class="help-info-card">
      <div class="help-info-content">
        <div class="help-info-item">
          <div class="help-info-title">
            <b-icon icon="file-earmark-spreadsheet" class="mr-2"></b-icon>
            Descargar
          </div>
          <p>Exportación estándar. Agrupa la información general por número de orden en una sola fila.</p>
        </div>
        <div class="help-info-item">
          <div class="help-info-title v4">
            <b-icon icon="lightning-fill" class="mr-2"></b-icon>
            Descargar Atenciones
          </div>
          <p>Exportación detallada. Incluye más datos (fecha de nacimiento, teléfono, recetas) y genera <strong>una fila por cada paciente</strong>, aunque pertenezcan a la misma orden.</p>
        </div>
      </div>
    </div>
  </transition>

  <div class="main-m">

<div class="filtro">

  <div style="display: inline-block;  right:0px; top:10px; margin-right: 10px;">
          Desde 
          <input
            id="x2"
            v-model="dt_dia"
            type="date"
          >
          </div>
          <div style="display: inline-block; margin-top:20px; margin-right: 10px;">
           Hasta
          <input
            id="x2"
            v-model="dt_dia2"
            type="date"
          >
        </div>

</div>
<button 
                    class="menuCol btn-ir-gordo"
                    style="padding: 5px 10px; margin: 0 auto; margin-top:10px;"
                    v-on:click="descargarCSV()"
                    :style="{'background-color':prestador.admin.assets.colors.primary}"> 
                    
                  <div v-if="!loading">
                    Descargar
                    <b-icon icon="download"></b-icon>
                  </div>
                  <div v-else style=" display: inline-block;">
                    Cargando...
                    <div
                      class="spinner-border spinner-border-sm"
                      role="status"
                    />
             
                  </div>

                  </button>
                  <button 
                    class="menuCol btn-ir-gordo"
                    style="padding: 5px 10px; margin: 0 auto; margin-top:10px;"
                    v-on:click="descargarCSV2()"
                    :style="{'background-color':prestador.admin.assets.colors.primary}"> 
                    
                  <div v-if="!loading">
                    Descargar Atenciones
                    <b-icon icon="download"></b-icon>
                  </div>
                  <div v-else style=" display: inline-block;">
                    Cargando...
                    <div
                      class="spinner-border spinner-border-sm"
                      role="status"
                    />
             
                  </div>

                  </button>



  </div>

  </div>


</transition>
<div v-if="showing" class="background-screen"></div>
</div>

</template>

<script>
/* eslint-disable */
import axios from 'axios';
import {mapGetters, mapActions} from 'vuex';

export default {
  name: 'ModalGenerico',
  components: {

  },
  props: {
   profesional_id:Number,
  },
  data(){
    return {
      showing:false,
      dt_dia:'',
      dt_dia2:'',
      desde:{d:0, m:0, a:0},
      hasta:{d:0, m:0, a:0},
      loading:false,
      showHelp: false,
    }
  },
  methods:{

   send_to(route){      
      document.body.style.position = '';
      document.body.style.top = '';
      this.$router.push({path:route})
      this.hide();
    },
    descargarCSV(){
      if (this.loading)
        return;
      this.loading = true;
      axios({
        url: window.hostname+'api/admin/exportar_ordenes',
        method: 'POST',
        responseType: 'blob',
        data: {
          dia:this.desde.d, mes:this.desde.m, año:this.desde.a,
          dia2:this.hasta.d, mes2:this.hasta.m, año2:this.hasta.a
        }
      })
      .then( (response) =>  {
        console.log(response);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'exportar_general.xlsx'); 
        document.body.appendChild(link);
        link.click();  
        this.loading = false;        
      })
      .catch(e=>{
        this.loading = false;        
        console.log(e);
      })

    },
    descargarCSV2(){
      if (this.loading)
        return;
      this.loading = true;
      axios({
        url: window.hostname+'api/v4/admin/exportar_consolidado',
        method: 'POST',
        responseType: 'blob',
        data: {
          dia:this.desde.d, mes:this.desde.m, año:this.desde.a,
          dia2:this.hasta.d, mes2:this.hasta.m, año2:this.hasta.a
        }
      })
      .then( (response) =>  {
        console.log(response);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'exportar_atenciones.xlsx'); 
        document.body.appendChild(link);
        link.click();  
        this.loading = false;        
      })
      .catch(e=>{
        this.loading = false;        
        console.log(e);
      })

    },
    show(){
      this.showing = true;
      /*document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${window.scrollY}px`;
      */
    },
    hide(){
      this.showing = false;
     /* document.body.style.position = '';
      document.body.style.top = '';
      */
    },



  },
  mounted(){
    var hoy = new Date()
    this.dt_dia = hoy.toISOString().split('T')[0]
    hoy.setDate(hoy.getDate());
    this.dt_dia2 = hoy.toISOString().split('T')[0]
  },
  computed:{
   ...mapGetters([
    'prestador',
    'comunas',
    'comunas_usadas',
    'categorias',
    'costo_servicio_pendiente',
    'examenes',
    'prestador_id',
    'categorias_selected',
    'prestador',
    ]),




  },
  watch:{
    dt_dia(val){

      var datos = val.split('-')
      this.desde = {a:Number(datos[0]), m:Number(datos[1]), d:Number(datos[2])}


    },
    dt_dia2(val){

        var datos = val.split('-')
        this.hasta = {a:Number(datos[0]), m:Number(datos[1]), d:Number(datos[2])}


    },
  
  },
}
</script>


<style scoped>
.btn-sig{
  border: none;
  padding: 4px 10px;
  border-radius: 4px;
  color:#fff;
}
.btn-sig:hover{
  opacity: 0.8;
}
.button-modal-m{
   padding:10px 40px;
   border: 2px solid rgba(0, 0, 0, 1);
   color: rgba(0, 0, 0, 1);
   font-weight: 600;
   display: inline-block;
   width: 300px;
   margin:10px;
   border-radius: 3px;
   cursor: pointer;
}
.button-modal-m:hover{
   background-color: rgba(0, 0, 0, 1);
   transition: 0.3s;
   color:white;
   box-shadow: rgba(0, 0, 0, 0.45) 0px 2px 10px 3px;
}
.background-screen{
  height: 100vh;
  width: 100vw;
  position: fixed;
 
/*   backdrop-filter: blur(2px); */
  z-index: 9999;

}
.titulo1{
  margin-bottom:30px;
  color: rgba(0, 0, 0, 1) !important;
}
.texto{
  text-align: center;
  padding: 0px 10px;
}
.main-m{
   display: flex;
   flex-wrap: wrap;
  width: 100%;
  text-align: center;
  padding: 10px;
  gap:10px;
}
.filtro{
   width: 100%;
   background-color: rgb(250, 250, 250);
   border-radius: 15px;
}
.greeny{
  color:#FF8C00;
  cursor:pointer;
  text-decoration: underline;
}
.subtitulo2{
  color:#FF8C00;
}
#modal-receta-m{
   transition: 0.5s;
   position:fixed;



   overflow-y:auto; 
   border-radius:10px;
   box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; 
   padding:10px; 
   background:white; 
   top: 50%;
   left:0px;
    transform: translateY(-50%);
  
   width:500px;
   max-width:90%;
   margin: 0px auto; 
   right: 0;
   opacity:1;
   z-index:99999;
}
.flaco{
   width:600px !important;
   left: 10% !important;
   transform: translate(-10%, -50%) !important;
}
#modal-receta-m h2{
     text-align: center;
     font-weight: bold;
     color:rgba(0,0,0,0.6);
     margin-top:20px;
}
#modal-receta-m h4{

  color:rgb(0, 0, 0) !important;
  margin-bottom:15px;
  margin-top:15px;
  font-size: 20px;
  font-weight: 700;
}
#modal-receta-m h5{
  text-align: center;
  vertical-align: middle;
  color:rgba(0, 0, 0, 0.3) !important;
 
}
.cont{
  text-align: center;
  vertical-align: middle;
  position:absolute;
   width:Calc(100% - 40px);
   top: 50%;
   left: 50%;
   transform: translate(-50%, -50%);
}
#modal-receta-m .icon{
   height:40px;
   width:40px;
   color:white;
}
#modal-receta-m .contenedor-icono{
   cursor:pointer;
   position:absolute;
   right:20px;
   top:20px;
   height:40px;
   width:40px;
   background-color: rgba(0, 0, 0, 1);
   border-radius:50px;
   z-index: 100001;
}
#modal-receta-m .subtitulo{
   text-align: center;
   font-size:22px;
   margin-bottom:40px;
   margin-top:20px;
   color:rgb(181, 181, 181);
   font-weight:350;
}
#modal-receta-m .input-wrapper{
   padding:0px 5px;
}
#modal-receta-m .btn-examinar{
   background-color:#FF8C00;
   padding:8px 20px;
   font-size:14px;
   font-weight:600;
   width:200px;
   max-width:Calc(100vw - 80px);
   color:white !important;
   outline: none;
   margin-top:20px;
}
#modal-receta-m .draggable-container{
   padding: 15px 5px 20px 5px;
   max-width: 600px;
   margin: 0 auto;
   background-color: rgb(247, 247, 247);
   border-style:dashed;
   border: 2px dashed rgb(200, 200, 200);
   border-radius:5px;
}
#modal-receta-m .comuna-container{
   position:absolute; 
   top:65px; 
   background-color:white;
   z-index: 999;
   border-radius: 0px 0px 4px 4px; 
   width:Calc(100% - 10px); 
   border: 1px solid rgb(200, 200, 200);
}
#modal-receta-m .placeholder-c{
   position:absolute; top:33px; left:20px;
}
#modal-receta-m .receta-label-mobile{
   display: none;
}
#modal-receta-m .btn-enviar{
   margin:0 auto; 
   cursor:pointer; 
   background-color:rgba(255, 179, 25, 1);
   max-width:300px; 
   height:45px; 
   color:white; 
   font-size:18px; 
   border-radius:4px;
   vertical-align: middle;
   font-weight:500;
}
#modal-receta-m .btn-enviar-d{
   margin:0 auto; 
   cursor:pointer; 
   background-color:rgba(255, 179, 25, 0.4);
   max-width:300px; 
   height:45px; 
   color:white; 
   font-size:18px; 
   border-radius:4px;
   vertical-align: middle;
   font-weight:500;
}
#modal-receta-m .upload-img{
   height:70px;
   width:70px;
   margin:0 auto; 
   margin-bottom:40px;
   margin-top:30px;
}
#modal-receta-m .email, .telefono, .isapre, .comuna{
 padding:4px;
 width:50%;
 text-align:left;
 vertical-align:top;
 display:inline-block;
 font-size:13px;
 padding-right:7px;
}
#modal-receta-m .comuna{
   position:relative;
}
#modal-receta-m .input-container{
   max-width:610px;
   margin: 0 auto;
}
@media only screen and (max-width: 1000px) {
   #modal-receta-m .btn-enviar{
   margin:0 auto; 
   margin-top:30px; 
   cursor:pointer; 
   background-color:rgba(103,30,117,1);
   max-width:100%;
   margin: 20px 20px; 
   height:55px; 
   line-height:55px;
   color:white; 
   font-size:18px; 
   border-radius:4px;
   font-weight:500;
}
#modal-receta-m .btn-examinar{
   padding:10px 20px;
   font-size:18px;
   font-weight:600;
   width:300px;
   max-width:Calc(100vw - 80px);
   color:white !important;
}
#modal-receta-m .receta-label-mobile{
   display: inline-block;
}
#modal-receta-m .email, .telefono, .isapre, .comuna{
 padding:4px;
 width:100%;
 text-align:left;
 vertical-align:top;
 display:inline-block;
 font-size:13px;
 padding:5px 20px;
 color:grey;
 
}
#modal-receta-m .placeholder-c{
   position:absolute; top:33px; left:30px;
}
#modal-receta-m .comuna-container{
   position:absolute; 
   top:65px; 
   background-color:white; 
   border-radius: 0px 0px 4px 4px; 
   width:Calc(100% - 40px); 
}
#modal-receta-m .receta-label-desk{
   display: none;
}
#modal-receta-m .draggable-container{
   border:none;
   background: none;
}
#modal-receta-m .contenido{
   z-index: 999999;
   position:relative;
      overflow-y:scroll !important;
   min-height:Calc(100vh);
   -webkit-overflow-scrolling: touch;
}
#modal-receta-m{
   position:fixed !important;
   height: auto !important;
   border-radius:10px !important;
   box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; 
   padding:20px 10px; 
   background:white; 
   top: 50% !important;
   width: 90vw !important;
   transform: translateY(-50%) !important;
   max-width:500px;
   max-height: 90%;
   margin: 0px auto !important; 
   left: 0px !important;
   right: 0px !important;
   opacity:1;
   z-index:90001;
}
.primary{
   display: block;
}
.texto{
  text-align: center;
}
}

.header-container-m {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 20px;
  position: relative;
}

#modal-receta-m h2 {
  margin: 0 !important;
  font-size: 24px;
}

.help-button-container {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #f1f5f9;
  color: #64748b;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #e2e8f0;
}

.help-button-container:hover {
  background-color: #e2e8f0;
  color: #1e293b;
  transform: scale(1.1);
}

.help-icon {
  font-size: 18px;
}

.help-info-card {
  margin: 15px 20px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  text-align: left;
}

.help-info-item {
  margin-bottom: 12px;
}

.help-info-item:last-child {
  margin-bottom: 0;
}

.help-info-title {
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 14px;
  color: #334155;
  margin-bottom: 4px;
}

.help-info-title.v4 {
  color: #2563eb;
}

.help-info-item p {
  font-size: 13px;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
}

/* Animations */
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.zoom-m-enter-active,
.zoom-m-leave-active {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-name: zoom-m;
}

.zoom-m-leave-active {
  animation-direction: reverse;
}

@keyframes zoom-m {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  100% {
    opacity: 1;
  }
}
</style>
